import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {getAdminById, getSupervisorById, openModal} from '../actions';
import {Layout, PageHeader, Spinner} from '../components';
import SupervisorModal from '../components/Modals/SupervisorModal';

const SupervisorsDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const {id} = params;
  const {supervisorById, supervisorsLoading} = useSelector(s => s.supervisors);

  const onBack = () => {
    navigate(-1);
  };

  const onDelete = () => {
    dispatch(openModal('DeleteModal', {item: supervisorById, type: 'supervisor'})); 
  };

  useEffect(() => {
    dispatch(getSupervisorById(id)); 
  }, []);

  return (
    <Layout>
      <PageHeader
        onBack={onBack}
        onDelete={onDelete}
        backText="Supervisors"
        title={`${supervisorById?.firstName || ''} ${supervisorById?.lastName || ''}`}
      />
      {!!supervisorById && <SupervisorModal supervisorToEdit={supervisorById} />}
    </Layout>
  );
};

export default SupervisorsDetails;
